import React, { Suspense, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { DataProvider } from "./Components/DataContext";
import DashboardEntry from "./Components/DashboardEntry";
const CMSManagement = React.lazy(() => import("./Pages/CMS Management/CMSManagement"));
const Layout = React.lazy(() => import("./Components/Layout/Layout"));
const SubAdminManagement = React.lazy(() => import("./Pages/SubAdmin Management/SubAdminManagement"));
const CreateNewProfile = React.lazy(() => import("./Pages/SubAdmin Management/CreateNewProfile"));
const SubAdminView = React.lazy(() => import("./Pages/SubAdmin Management/Sub-Admin-View"));
const Login = React.lazy(() => import("./Pages/Login/Login"));
const UpdatePassword = React.lazy(() => import("./Pages/Login/UpdatePassword"));
const ChangePassword = React.lazy(() => import("./Pages/Login/ChangePassword"));
const Dashboard = React.lazy(() => import("./Pages/Dashboard/Dashboard"));
const KamDashboard = React.lazy(() => import("./Pages/Kam/KamDashboard"));
const KamInquiryStatus = React.lazy(() => import("./Pages/Kam/KamInquiryStatus"));
const KamInquiryDetail = React.lazy(() => import("./Pages/Kam/KamInquiryDetail"));
const KamBookingStatus = React.lazy(() => import("./Pages/Kam/KamBookingStatus"));
const KamBookingDetail = React.lazy(() => import("./Pages/Kam/KamBookingDetail"));
const KamPackageInquiryStatus = React.lazy(() =>
  import("./Pages/Kam/KamPackageInquiryStatus")
);
const KamPackageInquiryDetail = React.lazy(() =>
  import("./Pages/Kam/KamPackageInquiryDetail")
);
const KamPackageBookingStatus = React.lazy(() =>
  import("./Pages/Kam/KamPackageBookingStatus")
);
const KamDisputeStatus = React.lazy(() => import("./Pages/Kam/KamDisputeStatus"));
const KamDisputeDetail = React.lazy(() => import("./Pages/Kam/KamDisputeDetail"));
const UserManagement = React.lazy(() => import("./Pages/UserManagement/UserManagement"));
const UserContactUsPage = React.lazy(() => import("./Pages/UserManagement/ContactUs"));
const ViewUser = React.lazy(() => import("./Pages/UserManagement/ViewUser"));
const UserEvent = React.lazy(() => import("./Pages/UserManagement/UserEvent"));
const ForgotPassword = React.lazy(() => import("./Pages/Login/ForgotPassword"));
const AuthLayout = React.lazy(() => import("./Components/Layout/AuthLayout"));
const EventManagement = React.lazy(() => import("./Pages/EventManagement/EventManagement"));
const ViewEvent = React.lazy(() => import("./Pages/EventManagement/EventView"))
const VendorNewView = React.lazy(() => import("./Pages/EventManagement/VendorNewView"))
const EventDetails = React.lazy(() => import("./Pages/EventManagement/EventDetails"))
const ServiceListingDetails = React.lazy(() => import("./Pages/EventManagement/ServiceListingDetails"))
const LabelManagement = React.lazy(() => import("./Pages/Label/LabelManagement"))
const FilterManagement = React.lazy(() => import("./Pages/Filter/FilterManagement"))
const ViewFilter = React.lazy(() => import("./Pages/Filter/ViewFilter"))
const ServiceManagement = React.lazy(() => import("./Pages/Service/ServiceManagement"))
const ServiceInner = React.lazy(() => import("./Pages/Service/ServiceDetails"))
const ServiceDetailsView = React.lazy(() => import("./Pages/Service/ServiceDetailsView"))
const CateringManagement = React.lazy(() => import("./Pages/Catering/CateringManagement"))
const AddCatering = React.lazy(() => import("./Pages/Catering/AddCatering"))
const MenuDetails = React.lazy(() => import("./Pages/Catering/MenuDetails"))
const ViewPackage = React.lazy(() => import("./Pages/Catering/ViewPackage"))
const ViewFoodItems = React.lazy(() => import("./Pages/Catering/ViewFoodItems"))
const CateringPresets = React.lazy(() => import("./Pages/Catering/CateringPresets"))

const TagManagement = React.lazy(() => import("./Pages/Tag/TagManagement"))
const BookingManagement = React.lazy(() => import("./Pages/BookingManagement/BookingManagement.jsx"))
const ViewBooking = React.lazy(() => import("./Pages/BookingManagement/ViewBooking"))
const ViewFoodDetails = React.lazy(() => import("./Pages/BookingManagement/ViewFoodDetails"))
const CouponManagement = React.lazy(() => import("./Pages/BookingManagement/CouponManagement"))
const CouponForm = React.lazy(() => import("./Pages/BookingManagement/CouponForm"))
const ShopOfferManagement = React.lazy(() =>
  import("./Pages/BookingManagement/ShopOfferManagement")
)
const EcommerceOrderManagement = React.lazy(() => import("./Pages/EcommerceOrders/EcommerceOrderManagement"))
const EcommerceOrderDetail = React.lazy(() => import("./Pages/EcommerceOrders/EcommerceOrderDetail"))
const EcommerceOrderItem = React.lazy(() => import("./Pages/EcommerceOrders/EcommerceOrderItem"))
const PackageManagementLayout = React.lazy(() =>
  import("./Pages/PackageManagement/PackageManagementLayout")
)
const PackageManagement = React.lazy(() => import("./Pages/PackageManagement/PackageManagement"))
const PackageBookingList = React.lazy(() =>
  import("./Pages/PackageManagement/PackageBookingList")
)
const PackageForm = React.lazy(() => import("./Pages/PackageManagement/PackageForm"))
const PackageInquiryList = React.lazy(() =>
  import("./Pages/PackageManagement/PackageInquiryList")
)
const PackageInquiryDetail = React.lazy(() =>
  import("./Pages/PackageManagement/PackageInquiryDetail")
)
const PackageDetail = React.lazy(() => import("./Pages/PackageManagement/PackageDetail"))
const PackagePreview = React.lazy(() => import("./Pages/PackageManagement/PackagePreview"))
const LandingPageManagement = React.lazy(() => import("./Pages/BookingManagement/LandingPageManagement"))
const CateringManagementBooking = React.lazy(() => import("./Pages/BookingManagement/CateringServices.jsx"))
const ProductManagement = React.lazy(() => import("./Pages/ProductManagement/ProductManagement"))
const TaxManagement = React.lazy(() => import("./Pages/ProductManagement/TaxManagement"))
const ProductDetails = React.lazy(() => import("./Pages/ProductManagement/ProductDetails"))
const CategoryDetails = React.lazy(() => import("./Pages/ProductManagement/CategoryDetails"))
const ViewCateringBooking = React.lazy(() => import("./Pages/BookingManagement/ViewCaterinBooking.jsx"))
const ChatbotFeedbackManagement = React.lazy(() => import("./Pages/ChatbotFeedback/ChatbotFeedbackManagement"))
const HelpAndSupportDetail = React.lazy(() => import("./Pages/ChatbotFeedback/HelpAndSupportDetail"))
const AdminDisputeDetail = React.lazy(() => import("./Pages/ChatbotFeedback/AdminDisputeDetail"))
const ViewFoodDetailsBooking = React.lazy(() => import("./Pages/BookingManagement/ViewFoodDetailsBooking.jsx"))
function App() {
  const isSessionExpired = () => {
    const lastActivityTime = localStorage.getItem("lastActivityTime");
    if (lastActivityTime) {
      return Date.now() - parseInt(lastActivityTime, 10) > 60 * 60 * 1000; // 1 hour in milliseconds
    }
    return true;
  };
  useEffect(() => {
    if (isSessionExpired()) {
      // localStorage.clear();
    }
  }, []);
  const PrivateOutlet = () => {
    const loginSuccess = useSelector((state) => state.loginInfo.userInformation);
    const storedStatus = localStorage.getItem("status");
    let isLoggedIn = false;
    try {
      isLoggedIn =
        (loginSuccess?.code === 200) ||
        (storedStatus && JSON.parse(storedStatus) === 200);
    } catch (error) {
      console.error("Error parsing localStorage data:", error);
    }
    return isLoggedIn ? <Outlet /> : <Navigate to="/" replace />;
  };
  return (
    <DataProvider>
      <Router>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<AuthLayout />}>
              <Route index element={<Login />} />
              <Route path="reset-password/:resetPasswordToken" element={<UpdatePassword />} />
              <Route path="forgot-password" element={<ForgotPassword />} />

            </Route>
            {/* Private Routes */}
            <Route element={<PrivateOutlet />}>
              <Route element={<Layout />}>
                <Route
                  path="dashboard"
                  element={
                    <DashboardEntry>
                      <Dashboard />
                    </DashboardEntry>
                  }
                />
                <Route path="/kam/dashboard" element={<KamDashboard />} />
                <Route path="/kam/inquiry-status/view" element={<KamInquiryDetail />} />
                <Route path="/kam/inquiry-status" element={<KamInquiryStatus />} />
                <Route path="/kam/booking-status/:bookingId" element={<KamBookingDetail />} />
                <Route path="/kam/booking-status" element={<KamBookingStatus />} />
                <Route path="/kam/package-inquiries/view/:id" element={<KamPackageInquiryDetail />} />
                <Route path="/kam/package-inquiries" element={<KamPackageInquiryStatus />} />
                <Route path="/kam/package-bookings" element={<KamPackageBookingStatus />} />
                <Route path="/kam/disputes/:disputeId" element={<KamDisputeDetail />} />
                <Route path="/kam/disputes" element={<KamDisputeStatus />} />
                <Route path="change-password" element={<ChangePassword />} />
                <Route path="user-management">
                  <Route index element={<UserManagement />} />
                  <Route path="contact-us" element={<UserContactUsPage />} />
                  <Route path="view-user">
                    <Route index element={<ViewUser />} />
                    <Route path="userevent" element={<UserEvent />} />
                  </Route>
                </Route>
                <Route path="cms-management" element={<CMSManagement />} />
                <Route path="/chatbot-feedbacks/help-support/view/:id" element={<HelpAndSupportDetail />} />
                <Route path="/chatbot-feedbacks/disputes/view/:id" element={<AdminDisputeDetail />} />
                <Route path="/chatbot-feedbacks" element={<ChatbotFeedbackManagement />} />
                <Route path="subadmin-management" element={<SubAdminManagement />} />
                <Route path="/vendor-management" element={<EventManagement />} />
                <Route path="/vendor-management/viewevent" element={<ViewEvent />} />
                <Route path="/vendor-management/newview" element={<VendorNewView />} />
                <Route path="/vendor-management/event-details" element={<EventDetails />} />
                <Route path="/vendor-management/service-listing-details" element={<ServiceListingDetails />} />
                <Route path="/subadmin-management" element={<SubAdminManagement />} />
                <Route path="/subadmin-management/add-role" element={<CreateNewProfile />} />
                <Route path="/subadmin-management/SubadminView" element={<SubAdminView />} />
                <Route path="/label-managemnt" element={<LabelManagement />} />
                <Route path="/tag-managemnt" element={<TagManagement />} />
                <Route path="/filter-managemnt" element={<FilterManagement />} />
                <Route path="/filter-managemnt/view-filter" element={<ViewFilter />} />
                <Route path="/service-managemnt" element={<ServiceManagement />} />
                <Route path="/service-managemnt/Inner" element={<ServiceInner />} />
                <Route path="/service-managemnt/service-details" element={<ServiceDetailsView />} />
                <Route path="/catering-management" element={<CateringManagement />} />
                <Route path="/catering-management/add" element={<AddCatering />} />
                <Route path="/catering-management/menu-details" element={<MenuDetails />} />
                <Route path="/catering-management/view-package" element={<ViewPackage />} />
                <Route path="/catering-management/view-food-items" element={<ViewFoodItems />} />
                <Route path="/catering-management/presets" element={<CateringPresets />} />
                <Route path="/booking-management" element={<BookingManagement />} />
                <Route path="/booking-management/catering" element={<CateringManagementBooking />} />
                <Route path="/booking-management/view-booking" element={<ViewBooking />} />
                <Route path="/booking-management/view-booking/food-details" element={<ViewFoodDetails />} />
                <Route path="/coupon-management/add" element={<CouponForm mode="add" />} />
                <Route path="/coupon-management/edit/:id" element={<CouponForm mode="edit" />} />
                <Route path="/coupon-management/view/:id" element={<CouponForm mode="view" />} />
                <Route path="/coupon-management" element={<CouponManagement />} />
                <Route path="/offer-management" element={<ShopOfferManagement />} />
                <Route
                  path="/booking-management/offer"
                  element={<Navigate to="/offer-management" replace />}
                />
                <Route
                  path="/ecommerce-orders/:channel/view/:id/item/:itemId"
                  element={<EcommerceOrderItem />}
                />
                <Route
                  path="/ecommerce-orders/:channel/view/:id"
                  element={<EcommerceOrderDetail />}
                />
                <Route
                  path="/ecommerce-orders/:channel"
                  element={<EcommerceOrderManagement />}
                />
                <Route
                  path="/ecommerce-orders"
                  element={<Navigate to="/ecommerce-orders/shop" replace />}
                />
                <Route path="/booking-management/coupon" element={<CouponManagement />} />
                <Route path="/package-management/add" element={<PackageForm mode="add" />} />
                <Route path="/package-management/edit/:id" element={<PackageForm mode="edit" />} />
                <Route path="/package-management/preview/:id" element={<PackagePreview />} />
                <Route path="/package-management/view/:id" element={<PackageDetail />} />
                <Route path="/package-management/inquiries/view/:id" element={<PackageInquiryDetail />} />
                <Route path="/package-management" element={<PackageManagementLayout />}>
                  <Route index element={<PackageManagement />} />
                  <Route path="inquiries" element={<PackageInquiryList />} />
                  <Route path="bookings" element={<PackageBookingList />} />
                </Route>
                <Route path="/booking-management/package" element={<Navigate to="/package-management" replace />} />
                <Route path="/booking-management/package/add" element={<Navigate to="/package-management/add" replace />} />
                <Route path="/booking-management/landing-page" element={<LandingPageManagement />} />
                <Route path="/product-management" element={<ProductManagement />} />
                <Route path="/tax-management" element={<TaxManagement />} />
                <Route path="/product-management/view/:id" element={<ProductDetails />} />
                <Route path="/product-management/categories/:id" element={<CategoryDetails />} />
                <Route path="/booking-management/view-catering-booking" element={<ViewCateringBooking />} />
                <Route
                  path="/booking-management/view-booking/food-details-booking/:bookingId"
                  element={<ViewFoodDetailsBooking />}
                />
                <Route path="/booking-management/view-booking/food-details-booking" element={<ViewFoodDetailsBooking />} />

              </Route>
            </Route>
          </Routes>
        </Suspense>
      </Router>
    </DataProvider>
  );
}

export default App;
